<template>
	<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.95003 12.0445L2.40553 8.49997L1.20703 9.69847L5.95003 14.45L16.15 4.24997L14.9515 3.04297L5.95003 12.0445Z" style="fill: var( --icon-color );"/>
	</svg>
</template>
